var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 0.513916C8.16421 0.513916 8.5 0.849702 8.5 1.26392V11.2639C8.5 11.6781 8.16421 12.0139 7.75 12.0139C7.33579 12.0139 7 11.6781 7 11.2639V1.26392C7 0.849702 7.33579 0.513916 7.75 0.513916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21967 6.73358C3.51256 6.44069 3.98744 6.44069 4.28033 6.73358L7.75 10.2033L11.2197 6.73358C11.5126 6.44069 11.9874 6.44069 12.2803 6.73358C12.5732 7.02647 12.5732 7.50135 12.2803 7.79424L8.28033 11.7942C7.98744 12.0871 7.51256 12.0871 7.21967 11.7942L3.21967 7.79424C2.92678 7.50135 2.92678 7.02647 3.21967 6.73358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 10.5139C1.16421 10.5139 1.5 10.8497 1.5 11.2639V13.2639C1.5 13.9543 2.05964 14.5139 2.75 14.5139H12.75C13.4404 14.5139 14 13.9543 14 13.2639V11.2639C14 10.8497 14.3358 10.5139 14.75 10.5139C15.1642 10.5139 15.5 10.8497 15.5 11.2639V13.2639C15.5 14.7827 14.2688 16.0139 12.75 16.0139H2.75C1.23122 16.0139 0 14.7827 0 13.2639V11.2639C0 10.8497 0.335786 10.5139 0.75 10.5139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d359b5efc4c9bd693912d70a305be2c5.svg";
export { ForwardRef as ReactComponent };